<template>
    <div class="app-container"></div>
</template>

<script>
import { getMpOpenId } from '@/api/jcc';
export default {
    name: 'business-push-message',
    data() {
        return {};
    },
    mounted() {
        let option = this.searchObj(location.search);
        if (option.bindYhbAppId && option.timestamp) {
            if (option.code) {
                getMpOpenId({
                    mpCode: option.code,
                    type: 2,
                    id: option.id,
                    unionId: option.unionId
                }) .then((res) => {
                })
                .finally((err) => {
                });
                return;
            }
            //https://h5-dl.yhbyf.com
            //https://devh5.yhbtest.com
            let loc_href = `https://h5-dl.yhbyf.com/business-push-message?bindYhbAppId=${option.bindYhbAppId}&id=${option.id}&unionId=${option.unionId}&timestamp=${option.timestamp}`;
            loc_href = encodeURIComponent(loc_href);
            var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb61c18690a32470d&redirect_uri=${loc_href}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`;
            location.href = url;
        }
    },
    methods: {
        // 处理重定向链接有相同code处理
        searchObj(str) {
            //去掉？
            var str = str.slice(1);
            //根据“&”分割字符串
            var arr = str.split('&');
            //定义空的obj，保存对象
            var obj = {};
            //循环遍历分割后的数组
            for (var p of arr) {
                //根据“=”分割
                var arr2 = p.split('=');
                //解构
                var [name, value] = arr2;
                //如果obj中的name为undefined就把值填进去，否则就连接
                if (obj[name] == undefined) {
                    obj[name] = value;
                } else {
                    obj[name] = [].concat(value, obj[name]);
                }
            }
            return obj;
        },
    },
};
</script>

<style scoped></style>
